import type { ReactNode, SelectHTMLAttributes } from "react";
import { ChevronDown, Search } from "lucide-react";
import { cn } from "@wa/ui";

/** The filter row under a page head: search, dropdowns, then tabs on the right.
 *
 *  `id` is here for the rows that are folded away behind a toggle: the toggle
 *  points at them with `aria-controls`, which needs something to point at. */
export function Toolbar({ children, className, id }: { children: ReactNode; className?: string; id?: string }) {
  return (
    <div id={id} className={cn("crm-tools", className)}>
      {children}
    </div>
  );
}

/** Pushes everything after it to the right edge of the toolbar. */
export function ToolbarGap() {
  return <span className="crm-push" />;
}

/** A raised pill that reads as one field, with the magnifier inside it. */
export function SearchField({
  value,
  onChange,
  placeholder,
  className,
  autoFocus,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  autoFocus?: boolean;
}) {
  return (
    <label className={cn("crm-fld", className)}>
      <Search className="size-4" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        spellCheck={false}
        autoFocus={autoFocus}
      />
    </label>
  );
}

